import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import { Box, Button, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { CategoryList } from '../../modules';
import { routePaths } from '../../routePaths';
import { PaddedContainer } from '../../ui-kit';

const CategoryListView = () => {
    const { t } = useTranslation();
    return (
        <PaddedContainer padding={4}>
            <Grid item xs={12}>
                <Box mb={4} display="flex" justifyContent="flex-end">
                    <Button
                        startIcon={<AddIcon />}
                        component={RouterLink}
                        to={routePaths.categoriesCreate}
                        variant="contained"
                        color="primary"
                    >
                        {t('New category')}
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <CategoryList />
            </Grid>
        </PaddedContainer>
    );
};

export default CategoryListView;
